import { render, staticRenderFns } from "./PermissionEditable.vue?vue&type=template&id=6a9677fa&"
import script from "./PermissionEditable.vue?vue&type=script&lang=js&"
export * from "./PermissionEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports